import { FC } from 'react'
import { Card } from 'antd'
import { IPaymentSummaryData } from '@/supabase/DailySalesSummary/dailySalesSummary.interface'

interface PaymentSummaryDisplayProps {
  paymentSummary: IPaymentSummaryData
  loading?: boolean
}

export const PaymentSummaryDisplay: FC<PaymentSummaryDisplayProps> = ({
  paymentSummary,
  loading = false
}) => {
  const formatBaht = (amount: number) => {
    return `${new Intl.NumberFormat('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount)} บาท`
  }

  return (
    <Card 
      title={
        <div className="flex items-center">
          <span className="font-medium">สรุปการชำระเงิน</span>
        </div>
      }
      loading={loading}
      className="h-full"
    >
      <div className="space-y-3">
        <Card size="small" className="border border-gray-300 rounded-lg">
          <div className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div className="flex flex-col">
                <span className="text-sm sm:text-base text-gray-600 mb-1">จ่ายแล้ว สด</span>
                <span className="font-semibold text-base sm:text-lg text-green-600">{formatBaht(paymentSummary.totalCashPayments)}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-sm sm:text-base text-gray-600 mb-1">จ่ายแล้ว โอน</span>
                <span className="font-semibold text-base sm:text-lg text-green-600">{formatBaht(paymentSummary.totalTransferPayments)}</span>
              </div>
            </div>
            <div className="border-t pt-3">
              <div className="flex flex-col">
                <span className="text-sm sm:text-base text-gray-600 mb-1">จ่ายรวม</span>
                <span className="font-bold text-lg sm:text-xl text-gray-800">{formatBaht(paymentSummary.totalPayments)}</span>
              </div>
            </div>
          </div>
        </Card>
        <Card size="small" className="border border-red-200 bg-red-50 rounded-lg">
          <div className="flex flex-col">
            <span className="text-sm sm:text-base text-red-500 mb-1">ค้างจ่าย</span>
            <span className="font-bold text-lg sm:text-xl text-red-600">{formatBaht(paymentSummary.totalOutstandingBalance)}</span>
          </div>
        </Card>
      </div>
    </Card>
  )
}